import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zm-.5 1.5l1.96 2.5H17V9.5h2.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9H8.22zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
        />
        <path
            d="M 4.877 11.466 L 13.43 11.466 L 13.814 11.956 L 14.429 12.153 L 14.314 14.845 L 3.992 14.845 L 3.829 12.175 L 4.568 11.982 L 4.877 11.466 Z"
            fill="currentColor"
        />
    </SvgIcon>
);
